import { render } from "./TableDropdown.vue?vue&type=template&id=79e0f821"
import script from "./TableDropdown.vue?vue&type=script&lang=js"
export * from "./TableDropdown.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\vue-notus-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__